import {Link} from 'react-router-dom';
import './GameCardModel.css';

export default function GameCardModel (props) {
    const picture = props.picture;
    const name = props.name
    const url = props.url
    const currentStyle = props.styleToApply
    return (
        <div className='games'>
           <Link to = {url}> <img src={picture} alt={name} style={currentStyle} className='home_images'/> </Link>
        </div> 
    );    
}